module.exports = __webpack_public_path__ + "img/关于我们.92241b4d.jpg";